import featureFlags from '../../../../feature_flags';

const { newsPageEnable } = featureFlags;
const data = {
  currentIssueCover: '//www.fastcompany.com/magazine/latest-cover.jpg',
  magazineLink: 'https://www.fastcompany.com/magazine/',
  subscribeLink: 'https://magazine.fastcompany.com/loc/FST/summersale',
  cosites: [
    {
      siteTitle: 'FastCoDesign',
      siteLogo:
        '//a.fastcompany.net/image/upload/v1488299643/fc/CO.DESIGN_BURGER_LOCKUP.svg',
      siteURL: '//www.fastcodesign.com'
    },
    {
      siteTitle: 'FastCoExist',
      siteLogo:
        '//a.fastcompany.net/image/upload/v1488299963/fc/CO.EXIST_BURGER_LOCKUP.svg',
      siteURL: '//www.fastcoexist.com'
    },
    {
      siteTitle: 'FastCoCreate',
      siteLogo:
        '//a.fastcompany.net/image/upload/v1488300422/fc/CO.CREATE_BURGER_LOCKUP.svg',
      siteURL: '//www.fastcocreate.com'
    },
    {
      siteTitle: 'FastCoStudios',
      siteLogo:
        '//a.fastcompany.net/image/upload/v1488300562/fc/video_burger.svg',
      siteURL: '//www.fastcompany.com/videos'
    }
  ],
  social: [
    {
      property: 'facebook',
      url: 'https://www.facebook.com/FastCompany/'
    },
    {
      property: 'twitter',
      url: 'https://twitter.com/fastcompany'
    },
    {
      property: 'instagram',
      url: 'https://www.instagram.com/fastcompany/'
    },
    {
      property: 'pocket',
      url: 'https://getpocket.com/explore/fastcompany.com'
    },
    {
      property: 'linkedin',
      url: 'https://www.linkedin.com/company/fast-company'
    }
  ],
  collections: [
    {
      title: 'fast company',
      className: 'main-menu__fastcompany-collection',
      sections: [
        {
          title: 'homepage',
          url: 'https://www.fastcompany.com'
        },
        {
          title: 'technology',
          url: 'https://www.fastcompany.com/technology'
        },
        {
          title: 'leadership',
          url: 'https://www.fastcompany.com/leadership'
        },
        {
          title: 'entertainment',
          url: 'https://www.fastcompany.com/entertainment'
        },
        {
          title: 'ideas',
          url: 'https://www.fastcompany.com/ideas'
        },
        {
          title: 'video',
          url: 'https://www.fastcompany.com/videos',
          external: true
        },
        {
          title: 'news',
          url: newsPageEnable ? '/news' : 'https://news.fastcompany.com',
          external: !newsPageEnable
        }
      ]
    },
    {
      title: 'co.Design',
      className: 'main-menu__codesign-collection',
      sections: [
        {
          title: 'homepage',
          url: 'https://www.fastcodesign.com'
        },
        {
          title: 'cities',
          url: 'https://www.fastcodesign.com/cities'
        },
        {
          title: 'graphics',
          url: 'https://www.fastcodesign.com/graphics'
        },
        {
          title: 'innovation by design',
          url: 'https://www.fastcodesign.com/innovation-by-design'
        },
        {
          title: 'interactive',
          url: 'https://www.fastcodesign.com/interactive'
        },
        {
          title: 'product',
          url: 'https://www.fastcodesign.com/product'
        },
        {
          title: 'spaces',
          url: 'https://www.fastcodesign.com/spaces'
        }
      ]
    },
    {
      title: 'collections',
      className: 'main-menu__collections',
      sections: [
        {
          title: 'The Most Innovative Companies',
          url: 'https://www.fastcompany.com/most-innovative-companies',
          deck:
            'The top 50 companies in entertainment, media, sports, technology, and more.',
          external: true
        },
        {
          title: 'Most Creative People',
          url: 'https://www.fastcompany.com/most-creative-people',
          deck: "Meet this year's inspiring leaders.",
          external: true
        },
        {
          title: 'Innovation By Design',
          url: 'https://www.fastcodesign.com/innovation-by-design',
          deck: 'A showcase for ingenious design solutions.',
          external: true
        },
        {
          title: 'Future of Philanthropy',
          url: 'https://www.fastcompany.com/section/future-of-philanthropy',
          deck: 'Inside The Changing World Of Giving'
        },
        {
          title: 'World Changing Ideas',
          url: 'https://www.fastcompany.com/section/world-changing-ideas',
          deck:
            'New workplaces, new food sources, new medicine—even an entirely new economic system.'
        },
        {
          title: 'Work Smart',
          url: 'https://www.fastcompany.com/section/work-smart',
          deck:
            'The apps, tips, tactics, and brain hacks to help you work smarter instead of harder.'
        },
        {
          title: 'FastCo.Works Studio',
          url: 'https://www.fastcompany.com/user/fastco-works',
          deck:
            'An award-winning team of journalists, designers, and videographers who tell brand stories through Fast Company’s distinctive lens.'
        }
      ]
    }
  ]
};

export default data;



// WEBPACK FOOTER //
// ./src/views/components/nav_main_menu/nav_main_menu_data.js